"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var CardFields_1 = __importDefault(require("./CardFields"));
// tslint:disable-next-line:max-line-length
var SecondCardTracking_1 = require("./SecondCardChallenge/SecondCardTracking");
var StripeContainer_1 = __importDefault(require("./StripeContainer"));
var VerifyCardError_1 = __importDefault(require("./VerifyCardError"));
var VerifyPaymentCardContext_1 = __importDefault(require("./VerifyPaymentCardContext"));
var VerifyPaymentCardMutation_1 = __importDefault(require("./VerifyPaymentCardMutation"));
var VerifyPaymentCard = function (_a) {
    var onClose = _a.onClose, onFinish = _a.onFinish, submitting = _a.submitting;
    var _b = React.useContext(VerifyPaymentCardContext_1["default"]), defaultCard = _b.defaultCard, orderCart = _b.orderCart, stripeKey = _b.stripeKey;
    // tslint:disable-next-line:max-line-length
    var defaultError = "We're unable to verify your payment card. Please try again";
    return (React.createElement(StripeContainer_1["default"], { stripeKey: stripeKey },
        React.createElement(VerifyPaymentCardMutation_1["default"], null, function (verifyPaymentCard, res) { return (React.createElement(CardFields_1["default"], { customError: React.createElement(VerifyCardError_1["default"], { defaultError: defaultError, submitRes: res }), isInline: false, onSubmit: function (token) {
                return verifyPaymentCard(defaultCard.id, token);
            }, submitRes: res, onClose: onClose, submitting: submitting, onFinish: onFinish, paymentCardTracking: SecondCardTracking_1.verifyPaymentCardTracking(orderCart.id), supportBillingAddress: true })); })));
};
exports["default"] = VerifyPaymentCard;
